<template>
  <section class="help-page">
    <Header />
    <Main />
    <Footer />
  </section>
</template>

<script>
import Header from "@/components/landing/Header";
import Main from "@/components/help/Main";
import Footer from "@/components/landing/Footer";
import {updateMetaTag, updateCanonical} from "@/utils/useHeadUtils"

export default {
  components: {
    Header,
    Main,
    Footer,
  },
  mounted() {
    const title = 'Site Palette Help: Getting Started, Features, Pricing & FAQ';
    const description = 'Learn how to log in, extract color palettes from websites, explore Site Palette features, and find answers to common questions about pricing and subscriptions.';

    document.title = title;
    updateMetaTag('description', description);
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateCanonical('https://palette.site/help');
  },
};
</script>
<style scoped>

* {
  color: #3d3d3d;
}

.help-page {
  width: 100%;
  box-sizing: border-box;
}

</style>
